import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IUserInfo } from 'libs/sdk/src/lib/user-info';

import { sdk } from '@/services';

const UserInfoService = sdk.getService('UserInfoService');

export const useMutateUserInfos = (userId: string) => {
  const queryClient = useQueryClient();
  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: ['user-info', userId]
    });
    queryClient.invalidateQueries({
      queryKey: ['students']
    });
    queryClient.invalidateQueries({
      queryKey: ['profile']
    });
    queryClient.invalidateQueries({
      queryKey: ['complete-profile-percentage']
    });
  };

  const { mutate: updateUserInfo, isPending: isUpdating } = useMutation({
    mutationFn: (update: Partial<IUserInfo>) => UserInfoService.updateUserInfo(userId, update),
    onSuccess
  });

  return {
    updateUserInfo,
    isWorking: isUpdating
  };
};
